import React, { useState, useRef, useEffect } from 'react';
import video from '../assets/wed_open.mp4';
import './InvitationVideo.css';

const InvitationVideo = ({ onVideoEnd }) => {
  const [isClicked, setIsClicked] = useState(false);
  const [isFading, setIsFading] = useState(false);
  const [isReady, setIsReady] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    // Add no-scroll class to body when component mounts
    document.body.classList.add('no-scroll');

    // Set a timeout to allow the font to load before fading in
    const timer = setTimeout(() => {
      setIsReady(true);
    }, 500); // Adjust this delay as needed

    // Cleanup function: remove no-scroll class when component unmounts
    return () => {
      clearTimeout(timer);
      document.body.classList.remove('no-scroll');
    };
  }, []);

  const handlePlay = () => {
    if (isClicked) return;

    setIsClicked(true);
    if (videoRef.current) {
      videoRef.current.play();
      setTimeout(() => {
        setIsFading(true);
      }, 5000); // Start fading after 5 seconds
    }
  };

  const handleTransitionEnd = () => {
    if (isFading) {
      onVideoEnd();
      // Remove no-scroll class when video fades out and onVideoEnd is called
      document.body.classList.remove('no-scroll');
    }
  };

  return (
    <div
      className={`video-container ${isFading ? 'fading' : ''} ${isReady ? 'ready' : ''} ${isClicked ? 'video-playing' : ''}`}
      onClick={handlePlay}
      onTransitionEnd={handleTransitionEnd}
    >
      <video
        ref={videoRef}
        src={video}
        muted
        playsInline
        preload="metadata" /* Preload video metadata */
      />
      {!isClicked && <div className="play-button">Click to Open</div>}
    </div>
  );
};

export default InvitationVideo;